import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { RedirectIfAuthed, RequireAdmin, RequireAuth } from './components/Guards';
import { useMeta } from './lib/queries';
import { Landing } from './pages/Landing';
import { Pricing } from './pages/Pricing';
import { About } from './pages/About';
import { ForgotPassword, Login, Register, ResetPassword, VerifyEmail } from './pages/Auth';
import { Onboarding } from './pages/Onboarding';
import { Dashboard } from './pages/Dashboard';
import { ExamRunner } from './pages/ExamRunner';
import { Results } from './pages/Results';
import { Review } from './pages/Review';
import { Practice } from './pages/Practice';
import { Revision } from './pages/Revision';
import { History } from './pages/History';
import { Account } from './pages/Account';
import { Admin } from './pages/Admin';
import { Marketplace } from './pages/Marketplace';
import { MarketplaceTerms, Privacy, Refunds, Terms } from './pages/Legal';

export function App() {
  const { data: meta } = useMeta();
  // The marketplace routes are not registered at all when the flag is off, so
  // the feature is invisible rather than merely unlinked.
  const marketplaceOn = meta?.features.textbookSwap ?? false;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<RedirectIfAuthed><Landing /></RedirectIfAuthed>} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="about" element={<About />} />

        <Route path="login" element={<RedirectIfAuthed><Login /></RedirectIfAuthed>} />
        <Route path="register" element={<RedirectIfAuthed><Register /></RedirectIfAuthed>} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="verify-email" element={<VerifyEmail />} />

        <Route path="onboarding" element={<RequireAuth allowUnonboarded><Onboarding /></RequireAuth>} />
        <Route path="dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
        <Route path="exam/:sessionId" element={<RequireAuth><ExamRunner /></RequireAuth>} />
        <Route path="results/:benchmarkId" element={<RequireAuth><Results /></RequireAuth>} />
        <Route path="review/:sessionId" element={<RequireAuth><Review /></RequireAuth>} />
        <Route path="practice" element={<RequireAuth><Practice /></RequireAuth>} />
        <Route path="revision" element={<RequireAuth><Revision /></RequireAuth>} />
        <Route path="history" element={<RequireAuth><History /></RequireAuth>} />
        <Route path="account" element={<RequireAuth allowUnonboarded><Account /></RequireAuth>} />
        <Route path="admin" element={<RequireAdmin><Admin /></RequireAdmin>} />

        {marketplaceOn ? (
          <>
            <Route path="marketplace" element={<RequireAuth><Marketplace /></RequireAuth>} />
            <Route path="marketplace-terms" element={<MarketplaceTerms />} />
          </>
        ) : null}

        <Route path="terms" element={<Terms />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="refunds" element={<Refunds />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
